export const blockIconsHardwareKeyboardArrowLeftNew = (
	<span className='material-symbols-outlined'>keyboard_arrow_left</span>
);
